import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/home/dola/Code/javascript/nextjs/sucre/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNav"] */ "/home/dola/Code/javascript/nextjs/sucre/src/components/MobileNav.tsx");
